import { TeacherType } from "../interfaces/actionTypes";
import axios from "axios";
import { CourseData, LoginData, RegisterData, TeacherActionType } from "../interfaces/interfaces";
import { Dispatch } from "react";
import Swal from "sweetalert2";

export function teacherLogin(loginData: LoginData) {
  return async function (dispatch: Dispatch<TeacherActionType>) {
    try {
      setLoading();
      const res = await axios.post("/user/teacher/login", loginData);
      console.log(res.data);
      if (res.data.success === true) {
        return dispatch({
          type: TeacherType.LOGIN,
          payload: res.data
        })
      }
      if (res.data.success === false) {
        await Swal.fire({
          icon: "error",
          text: res.data.message
        })
        return dispatch({
          type: TeacherType.AUTH_ERROR,
          payload: res.data
        })
      }
    } catch (err) {
      console.log(err)
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function teacherRegister(registerData: RegisterData) {
  return async function (dispatch: Dispatch<TeacherActionType>) {
    try {
      setLoading();
      const res = await axios.post("/user/teacher/register", registerData);
      if (res.data.success === true) {
        return dispatch({
          type: TeacherType.REGISTER,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
      if (res.data.success === false) {
        return dispatch({
          type: TeacherType.AUTH_ERROR,
          payload: res.data
        })
      }
    } catch (error) {
      console.log(error)
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function getTeacherOwnedCourses(token: string) {
  return async function (dispatch: Dispatch<TeacherActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      setLoading();
      const res = await axios.get("/user/teacher/course", config)
      console.log(res.data);
      if (res.status === 200) {
        return dispatch({
          type: TeacherType.GET_COURSES,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
    } catch (error) {
      console.log(error)
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function teacherCreateCourse(courseData: CourseData, token: string) {
  return async function (dispatch: Dispatch<TeacherActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      setLoading();

      const res = await axios.post("/user/teacher/create-course", courseData, config);
      if (res.data.success === true) {
        await Swal.fire({
          icon: "success",
          text: "Course created successfully"
        })
        return dispatch({
          type: TeacherType.CREATE_COURSES,
          payload: res.data
        })
      }
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: res.data
      })
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
    } catch (err) {
      console.log(err)
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function getUploadedAssignments(token: string) {
  return async function (dispatch: Dispatch<TeacherActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      setLoading();

      const res = await axios.get("/user/teacher/uploaded-assignments", config);
      if (res.data.success === true) {
        return dispatch({
          type: TeacherType.GET_ASSIGNMENTS,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: `${res.data.message}`
      })
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function getUploadedNotes(token: string) {
  return async function (dispatch: Dispatch<TeacherActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      setLoading();

      const res = await axios.get("/user/teacher/uploaded-notes", config);
      if (res.data.success) {
        return dispatch({
          type: TeacherType.GET_NOTES,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: `${res.data.message}`
      })
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function getUploadedLessons(token: string) {
  return async function (dispatch: Dispatch<TeacherActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      setLoading();

      const res = await axios.get("/user/teacher/uploaded-videos", config);
      if (res.data.success) {
        return dispatch({
          type: TeacherType.GET_LESSONS,
          payload: res.data
        })
      }
      await Swal.fire({
        icon: "error",
        text: `${res.data.message}`
      })
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function getSubmittedAssignments(token: string) {
  return async function (dispatch: Dispatch<TeacherActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      setLoading();

      const res = await axios.get("/user/teacher/assignments", config);
      console.log(res.data);
      if (res.data.success) {
        return dispatch({
          type: TeacherType.GET_SUBMITTED_ASSIGNMENTS,
          payload: res.data.submitted_assignments
        })
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
    }
  }
}

export function gradeAssignment(token: string, data: any) {
  return async function (dispatch: Dispatch<TeacherActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      const res = await axios.post("/user/teacher/grade-assignment", data, config);
      console.log(res.data);
      if (res.data.success) {
        dispatch({
          type: TeacherType.GRADE_ASSIGNMENT,
          payload: res.data.message
        });
        return await Swal.fire({
          icon: "success",
          text: `${res.data.message}`
        })
      }
      await Swal.fire({
        icon: "error",
        text: res.data.message
      })
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: res.data.message
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: TeacherType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
    }
  }
}

export function teacherLogout() {
  localStorage.removeItem("vidcom");
  return {
    type: TeacherType.LOGOUT,
  };
}

export function setLoading() {
  return {
    type: TeacherType.LOADING,
  };
}